import { createAction } from 'typesafe-actions';
import { ChatInfo } from './types';

export const INIT_CHAT_INFO = 'chat/INIT_CHAT_INFO';

export const UPDATE_CHAT_ROOM = 'chat/UPDATE_CHAT_ROOM';

export const UPDATE_CHAT_INFO = 'chat/UPDATE_CHAT_INFO';

export const UPDATE_CHAT_MESSAGES = 'chat/UPDATE_CHAT_MESSAGES';

export const initChatInfo = createAction(INIT_CHAT_INFO)();

export const updateChatInfo = createAction(UPDATE_CHAT_INFO)<ChatInfo>();
